/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  workorderBillsPendingApproval: [],
  workorderBillsApprovedForPayment: [],
  loadingBills: false,
  downloadingBills: false,
  updatingBills: false,
  serverError: '',
};

export const actions = {
  async getWorkorderBillsPendingApproval({ commit }) {
    await api.get('/workorderbill/pendingapproval').then(async (response) => {
      commit('SET_WORKORDER_BILLS_PENDING_APPROVAL', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_SERVER_ERROR', exception);
    });
  },
  async getWorkorderBillsApprovedForPayment({ commit }) {
    commit('SET_SERVER_ERROR', '');
    commit('SET_LOADING_BILLS', true);
    api.get('/workorderbill/approvedForPayment').then(async (response) => {
      commit('SET_WORKORDER_BILLS_APPROVED_FOR_PAYMENT', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_SERVER_ERROR', exception);
    }).finally(() => {
      commit('SET_LOADING_BILLS', false);
    });
  },
  async markBillsAsPaid({ commit, dispatch }, ids) {
    commit('SET_UPDATING_BILLS', true);
    api.put('/workorderbill/paidbills', ids).then(async (response) => {
      dispatch('getWorkorderBillsApprovedForPayment');
    })
      .catch((exception) => commit('SET_SERVER_ERROR', exception))
      .finally(() => commit('SET_UPDATING_BILLS', false));
  },
  async downloadBills({ commit, dispatch }, ids) {
    commit('SET_DOWNLOADING_BILLS', true);
    api.put('/workorderbill/approvedbillsfile', ids, { responseType: 'blob' })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'bills.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((exception) => commit('SET_SERVER_ERROR', exception))
      .finally(() => commit('SET_DOWNLOADING_BILLS', false));
  },
};

export const mutations = {
  SET_WORKORDER_BILLS_PENDING_APPROVAL(state, data) {
    state.workorderBillsPendingApproval = data;
  },
  SET_SERVER_ERROR(state, data) {
    state.serverError = data;
  },
  SET_DOWNLOADING_BILLS(state, data) {
    state.downloadingBills = data;
  },
  SET_LOADING_BILLS(state, data) {
    state.loadingBills = data;
  },
  SET_UPDATING_BILLS(state, data) {
    state.updatingBills = data;
  },
  SET_WORKORDER_BILLS_APPROVED_FOR_PAYMENT(state, data) {
    state.workorderBillsApprovedForPayment = data;
  },
};

export const getters = {
  approvedWorkOrderBills: (state) => state.workorderBillsApprovedForPayment.map((bill) => {
    let vendorName = '';
    if (bill.workOrder && bill.workOrder.vendorContact && bill.workOrder.vendorContact != null) {
      vendorName = `${bill.workOrder.vendorContact.firstName} ${bill.workOrder.vendorContact.lastName}`;
    } else if (bill.workOrder.vendorOrganization && bill.workOrder.vendorOrganization != null) {
      vendorName = bill.workOrder.vendorOrganization.name;
    }
    return {
      id: bill.id,
      invoiceNumber: bill.billIdentifier,
      projectName: bill.project.projectName,
      projectId: bill.project.projectId,
      projectManager: bill.projectManager ? `${bill.projectManager.firstName} ${bill.projectManager.lastName}` : '',
      projectManagerEmail: bill.projectManager ? bill.projectManager.emailAddress : '',
      workOrderNumber: bill.workOrder ? bill.workOrder.workOrderNumber : null,
      workOrderId: bill.workOrder ? bill.workOrder.id : null,
      vendor: vendorName,
      receivedDate: bill.receivedDate,
    };
  }),
};
